<template>
  <div :data-dp-id="dp_id" class="trend-btn" @mouseover="over()" v-show="!(/[a-zA-Z]/).test(dp_id)">
    <span>价格走势</span>
    <div class="popup-trend-area" ref="popup" style="top: 22px">
      <div class="area-head">
        <div class="p-status">
          <i class="status-icon i-steady"></i>
          <span class="status-txt" data-s-d="0">价格平稳</span>
        </div>
        <div class="price-info">
          <div class="info-item" id="ymj">
            <p class="max">最高: <span class="max-price"></span></p>
            <p class="min">
              <span class="min-title">最低</span
              ><span class="tag">单&nbsp;&nbsp;&nbsp;件</span>:
              <span class="min-price"></span><span class="date"></span>
            </p>
          </div>
          <div class="info-item" id="cdj">
            <p class="max"><span class="placeholder"></span></p>
            <p class="min">
              最低<span class="tag">多&nbsp;&nbsp;&nbsp;件</span>:
              <span class="min-price"></span><span class="date"></span>
            </p>
            <a class="morePromo" href="#" target="_blank">历史促销明细></a>
          </div>
        </div>
      </div>
      <div class="hover-price-info">
        <p class="current-date"></p>
        <div class="price-list">
          <div class="info-item" id="ymj">
            <i class="icon circle-blue"></i>
            <span class="title">页面价</span>
            <span class="colon">:</span>
            <span class="ymj-price price"></span>
          </div>
          <div class="info-item" id="dsj">
            <i class="icon circle-blue-o"></i>
            <span class="title">到手价(单件)</span>
            <span class="colon">:</span>
            <span class="dsj-price price"></span>
            <span class="promo-msg"></span>
          </div>
          <div class="info-item" id="cdj">
            <i class="icon circle-orange"></i>
            <span class="title">到手价(多件)</span>
            <span class="colon">:</span>
            <span class="cdj-price price"></span>
            <span class="promo-msg"></span>
          </div>
        </div>
      </div>
      <div class="popup-chart-loading">
        <p>加载中...</p>
      </div>
      <div class="no-data">
        <img src="/template/metro/images/collection/no-trend-data@2x.png" />
        <p>抱歉，该商品暂无价格走势情况</p>
      </div>
      <div :id="'popup-chart-' + dp_id" class="area-content"></div>
    </div>
  </div>
</template>
<style scoped lang="less">
.trend-btn {
  display: inline-block;
  width: 60px;
  height: 26px;
  cursor: pointer;
  background: rgba(94, 190, 255, 0.15);
  border-radius: 2px 2px 2px 2px;
  font-size: 12px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-top: 20px;
  text-align: center;
  position: relative;
}

.icon {
  margin-right: 6px !important;
}

.title {
  margin-left: 0px !important;
}

.colon {
  margin-right: 8px !important;
}

.price {
  margin-left: 0px !important;
  font-size: 12px !important;
  margin-right: 0px !important;
}

.trend-btn:hover {
  .popup-trend-area {
    display: block;
    z-index: 102;
  }
}
</style>
<script>
import siteConfig from "../configs/site";

let dps = [],
  loaded_dpids = [],
  _promotions = [],
  _quans = [];

export default {
  props: ["dp_id", "site_id", "getCurrency"],
  data() {
    return {
      drawed: false,
      istb: false,
    };
  },
  methods: {
    over() {
      let dp_id = this.dp_id;
      if (loaded_dpids.indexOf(dp_id) !== -1) {
        PopupTrend.config({
          popup_dom: $(this.$refs.popup),
          istb: this.istb,
          dp_id: dp_id,
          promotions: _promotions[dp_id],
          quan_price: _quans[dp_id],
          currency: this.getCurrency(this.site_id),
        });
      }
      if (!this.drawed) {
        this.draw();
        this.drawed = true;
      }
    },
    draw() {
      const self = this;
      let popover = $(this.$refs.popup);
      let dp_id = this.dp_id;
      let x = this.dp_id?.split("-");
      let site_id = "83";
      if (x?.length > 1) {
        site_id = x[1];
      }
      let site_name = siteConfig[site_id] ? siteConfig[site_id] : site_id;
      let show_chart_legend = true;
      let serie_name = "到手价(单件)";
      if (site_name.indexOf("天猫") >= 0 || site_name.indexOf("淘宝") >= 0) {
        this.istb = true;
        serie_name = "页面价";
        show_chart_legend = false;
      }
      let cur = this.getCurrency(this.site_id);
      let chart_id = "";

      if (loaded_dpids.indexOf(dp_id) !== -1) {
        // 已经加载过
        PopupTrend.config({
          popup_dom: popover,
          istb: this.istb,
          dp_id: dp_id,
          promotions: _promotions[dp_id],
          quan_price: _quans[dp_id],
          currency: cur,
        });
      } else {
        chart_id = popover.children(".area-content").attr("id");

        trend_data.get_trend_data(
          "",
          dp_id,
          "",
          "",
          function (data) {
            if (data && data.is_ban !== undefined && data.is_ban == 1) {
              window.location.href = resp.action.to;
              return;
            }

            loaded_dpids.push(dp_id);
            _promotions[dp_id] = [];

            if (data.promo_detail !== undefined) {
              _promotions[dp_id] = data.promo_detail;
            }

            _quans[dp_id] = 0;
            if (data.coupon !== undefined && data.coupon.amount) {
              _quans[dp_id] = data.coupon.amount;
            }

            let promo_serie, serie;

            if (data.promo_series !== undefined) {
              if (data.promo_series?.length > 2)
                promo_serie = data.promo_series[1];
              else
                promo_serie = data.promo_series[data.promo_series?.length - 1];

              promo_serie.site_name = site_name;
              promo_serie.series_name = "到手价(多件)";
              promo_serie.is_promo = true;
            } else {
              promo_serie = null;
            }

            if (data.series && data.series?.length) {
              if (data.series?.length > 2)
                serie = data.series[1]; // 默认展示180天
              else serie = data.series[data.series?.length - 1];

              serie.site_name = site_name;
              serie.series_name = serie_name;
              serie.is_promo = false;
            } else {
              serie = null;
            }

            if (serie && serie.data) {
              if (serie.trend == -1 && serie.current == serie.min) {
                serie.trend = -2;
              }
              popover.find(".popup-chart-loading").hide();

              let drawOptions = {
                popup_dom: popover,
                istb: self.istb,
                dp_id: dp_id,
                series: [serie],
                promo_series: promo_serie ? [promo_serie] : [],
                promotions: _promotions[dp_id],
                quan_price: _quans[dp_id],
                show_legend: show_chart_legend,
                currency: cur,
                callback_before_draw: function (chart_options) {
                  if (chart_options.series?.length === 1) {
                    let popover_w = popover.width();
                    let _h = 330;
                    popover.css({
                      height: _h + "px",
                      "background-size": popover_w + "px " + _h + "px",
                    });
                  }
                },
                callback_after_draw: function (chart) {},
              };
              PopupTrend.init(chart_id, drawOptions);
            } else {
              // no data
              popover
                .find(".area-head,.popup-chart-loading,.area-content")
                .hide();
              popover.find(".no-data").show();
            }
          },
          2,
          1,
          0,
          1
        );
      }
    },
  },
};
</script>
